import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { Table, Input, Button } from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import ExportJsonExcel from "js-export-excel";
import Header from "../../layout/Header/Header";
import SurtirPedidoModal from "../../SurtirPedidoModal";
import { folioVendedor } from "../../folioVendedor";

// Reporte sencillo: un renglon por pedido abierto con su orden de compra, su
// embarque y su recepcion, para saber que ya se puede surtir. El calculo de
// "Puedes surtir" esta en el back (seguimientoPedidos).
const headers = () => ({ Authorization: `Bearer: ${localStorage.getItem("app_token")}` });
const num = (n) => new Intl.NumberFormat("en-US").format(Number(n) || 0);
const LISTOS = ["Listo para surtir", "Surtir parcial"];
const colorEstado = (e) => (e === "Listo para surtir" ? "#15803d"
  : e === "Surtir parcial" || e === "Recibido, falta autorizar" ? "#b45309"
    : e === "Recibido sin existencia" ? "#dc2626" : "#64748b");
const orden = (f) => { const i = [...LISTOS, "Recibido, falta autorizar"].indexOf(f.estado); return i < 0 ? 9 : i; };

function Avance({ q, total, sub }) {
  const pct = total ? Math.min(100, Math.round((q / total) * 100)) : 0;
  return (
    <div style={{ minWidth: 120 }}>
      <div style={{ whiteSpace: "nowrap" }}>{q ? <><b>{num(q)}</b> <span style={{ color: "#94a3b8" }}>de {num(total)}</span></> : <span style={{ color: "#94a3b8" }}>—</span>}</div>
      <div style={{ height: 4, background: "#e2e8f0", borderRadius: 2, margin: "2px 0" }}>
        <div style={{ width: `${pct}%`, height: 4, borderRadius: 2, background: pct >= 100 ? "#16a34a" : "#0ea5e9" }} />
      </div>
      {sub ? <div style={{ fontSize: 11, color: "#64748b" }}>{sub}</div> : null}
    </div>
  );
}

function SeguimientoPedidos() {
  const { user } = useContext(AuthContext);
  const puede = !!user.menu_pedidos || !!user.menu_reportes || !!user.menu_ventas;
  const [filas, setFilas] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [buscar, setBuscar] = useState("");
  const [estado, setEstado] = useState("");
  const [pedidoSurtir, setPedidoSurtir] = useState(null);

  function carga() {
    setCargando(true);
    axios.get(`${process.env.REACT_APP_URL_SEGUIMIENTOS}Pedidos`, { headers: headers() })
      .then((r) => {
        let lista = r.data || [];
        // el vendedor solo ve sus pedidos, igual que en el listado
        if (user.vendedor === "Si") lista = lista.filter((p) => p.vendedorEmail === user.email);
        setFilas(lista.map((p) => ({ ...p, folio: folioVendedor(p.colaboradores, p.consecutivoVendedor, p.divisionNumero) }))
          .sort((a, b) => (orden(a) - orden(b)) || (parseFloat(a.numero) - parseFloat(b.numero))));
        setCargando(false);
      })
      .catch((e) => {
        setCargando(false);
        Swal.fire({ icon: "error", title: "No se pudo cargar el reporte", text: e.response?.data?.message || e.message });
      });
  }
  useEffect(() => { carga(); }, []); // eslint-disable-line

  const estados = useMemo(() => [...new Set(filas.map((f) => f.estado))].sort(), [filas]);
  const q = buscar.trim().toUpperCase();
  const visibles = filas.filter((f) => (!estado || f.estado === estado)
    && (!q || [f.numero, f.folio, f.clientes, f.colaboradores, f.ordenCompraCliente, f.pos, f.contenedores]
      .some((x) => String(x || "").toUpperCase().includes(q))));
  const cuenta = (e) => filas.filter((f) => f.estado === e).length;
  const piezasSurtibles = filas.filter((f) => LISTOS.includes(f.estado)).reduce((s, f) => s + f.surtible, 0);

  const excel = () => new ExportJsonExcel({
    fileName: "SeguimientoPedidos",
    datas: [{
      sheetName: "Pedidos",
      sheetHeader: ["Pedido", "Consecutivo", "Tipo", "Cliente", "Vendedor", "OC Cliente", "Piezas", "En OC", "PO", "Embarcado", "Contenedor", "ETA", "Recibido", "Surtido", "Por surtir", "Puedes surtir", "Estado"],
      sheetData: visibles.map((f) => [f.numero, f.folio, f.tipo, f.clientes, f.colaboradores, f.ordenCompraCliente, f.piezas, f.enOC, f.pos, f.embarcado, f.contenedores, f.eta, f.recibido, f.surtidas, f.porSurtir, f.surtible, f.estado]),
    }],
  }).saveExcel();

  return (
    <>
      <Header />
      <br />
      <br />
      {puede ? (
        <div className="card container col-12">
          <div style={{ display: "flex", gap: 8, marginTop: 10 }}>
            <Button href="/MenuOperacion" size="sm" className="btn btn-danger">Regresar</Button>
            <Button size="sm" color="primary" onClick={excel} disabled={!visibles.length}>Excel</Button>
          </div>
          <h3 align="center" style={{ marginTop: 6 }}>Seguimiento de pedidos</h3>
          <p align="center" style={{ color: "#64748b", marginBottom: 12 }}>
            <b style={{ color: "#15803d" }}>{cuenta("Listo para surtir")}</b> listos ·{" "}
            <b style={{ color: "#b45309" }}>{cuenta("Surtir parcial")}</b> parciales ·{" "}
            <b>{num(piezasSurtibles)}</b> piezas que puedes surtir hoy ·{" "}
            <b style={{ color: "#b45309" }}>{cuenta("Recibido, falta autorizar")}</b> recibidos sin autorizar
          </p>
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 10 }}>
            <Input bsSize="sm" style={{ maxWidth: 340 }} placeholder="Pedido, cliente, vendedor, OC, PO o contenedor"
              value={buscar} onChange={(e) => setBuscar(e.target.value)} />
            <Input bsSize="sm" type="select" style={{ maxWidth: 240 }} value={estado} onChange={(e) => setEstado(e.target.value)}>
              <option value="">Todos los estados</option>
              {estados.map((e) => <option key={e} value={e}>{e}</option>)}
            </Input>
          </div>
          <div style={{ overflowX: "auto" }}>
            <Table size="sm" striped borderless className="table-responsive-xl">
              <thead>
                <tr>
                  <th className="tituloTabla">Pedido</th>
                  <th className="tituloTabla">Orden de compra</th>
                  <th className="tituloTabla">Embarque</th>
                  <th className="tituloTabla">Recepción</th>
                  <th className="tituloTabla" style={{ textAlign: "right" }}>Por surtir</th>
                  <th className="tituloTabla" style={{ textAlign: "right" }}>Puedes surtir</th>
                  <th className="tituloTabla">Estado</th>
                  <th className="tituloTabla"></th>
                </tr>
              </thead>
              <tbody>
                {cargando ? (
                  <tr><td colSpan={8} style={{ textAlign: "center", color: "#94a3b8" }}>Cargando...</td></tr>
                ) : !visibles.length ? (
                  <tr><td colSpan={8} style={{ textAlign: "center", color: "#94a3b8" }}>No hay pedidos con esos filtros.</td></tr>
                ) : visibles.map((f) => (
                  <tr key={f._id}>
                    <td style={{ whiteSpace: "nowrap" }}>
                      <b>{f.numero}</b>{f.folio ? <span style={{ color: "#64748b" }}> · {f.folio}</span> : null}
                      {f.tipo === "Prepedido" ? <span style={{ color: "#f59e0b", fontSize: 11, fontWeight: 700 }}> PREPEDIDO</span> : null}
                      <div style={{ fontSize: 12 }}>{f.clientes}</div>
                      <div style={{ fontSize: 11, color: "#64748b" }}>{f.colaboradores}{f.ordenCompraCliente ? ` · OC ${f.ordenCompraCliente}` : ""}</div>
                    </td>
                    <td><Avance q={f.enOC} total={f.piezas} sub={f.pos ? `PO ${f.pos}` : "Sin PO"} /></td>
                    <td><Avance q={f.embarcado} total={f.piezas} sub={[f.contenedores, f.eta ? `ETA ${f.eta}` : ""].filter(Boolean).join(" · ")} /></td>
                    <td><Avance q={f.recibido} total={f.piezas} /></td>
                    <td style={{ textAlign: "right" }}>{num(f.porSurtir)}</td>
                    <td style={{ textAlign: "right", fontWeight: 700, color: f.surtible ? colorEstado(f.estado) : "#94a3b8" }}>{num(f.surtible)}</td>
                    <td style={{ fontWeight: 600, fontSize: 13, color: colorEstado(f.estado) }}>{f.estado}</td>
                    <td>
                      {LISTOS.includes(f.estado) && user.surtidos_create ? (
                        <Button size="sm" color="success" onClick={() => setPedidoSurtir(f)}>
                          <i className="fas fa-truck-moving" /> Surtir
                        </Button>
                      ) : null}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          <p style={{ color: "#64748b", fontSize: 12 }}>
            Puedes surtir sale de la existencia por color y talla: primero lo recibido para cada pedido y lo demás del más antiguo al más nuevo.
          </p>
        </div>
      ) : undefined}

      <SurtirPedidoModal
        abierto={!!pedidoSurtir}
        cerrar={() => setPedidoSurtir(null)}
        pedido={pedidoSurtir}
        user={user.id}
        onSurtido={() => { setPedidoSurtir(null); carga(); }}
      />
    </>
  );
}

export default SeguimientoPedidos;
